module.exports = __webpack_public_path__ + "static/media/colloseum.394fb3dc.png";